import React, { useState } from 'react';

export default function BuildListForm({ listName, onBuildList, onCancel }) {
  const [description, setDescription] = useState('');
  const [isBuilding, setIsBuilding] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!description.trim()) return;

    setIsBuilding(true);
    try {
      await onBuildList(description.trim());
      setDescription('');
    } catch (error) {
      console.error('Error building list:', error);
      alert('Failed to build list. Please try again.');
    } finally {
      setIsBuilding(false);
    }
  };

  const exampleDescriptions = [
    "I need to complete a 4 page comic. For each page, I need to complete the following tasks: Pencil, Ink, Color, Shading and Lettering",
    "Things to do before vacation: pack suitcase, book airport parking, arrange pet care, set up mail forwarding, notify credit card company",
    "Home improvement projects for the kitchen: replace countertops, install new backsplash, upgrade lighting fixtures, paint cabinets, organize pantry"
  ];

  return (
    <div className="build-list-form-card">
      <div className="form-header">
        <h3 className="form-header-title">Populate List with AI</h3>
        <p className="form-header-subtitle">
          Describe what this list should contain, and we'll generate tasks for you.
        </p>
      </div>
      <div className="form-body">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="description" className="form-label">
              Description
            </label>
            <textarea
              id="description"
              className="form-textarea"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="e.g., I need to complete a 4 page comic. For each page, I need to complete the following tasks: Pencil, Ink, Color, Shading and Lettering"
              rows={4}
              disabled={isBuilding}
              aria-label="List description"
            />
            <div className="form-hints">
              <p className="form-hint-text">
                <strong>Tip:</strong> Be specific about what you want to accomplish. 
                If you mention repeating patterns (like "for each page"), we'll create one task per item with the steps as subtasks.
              </p>
            </div>
          </div>

          <div className="form-examples">
            <p className="form-examples-title">Example descriptions:</p>
            <ul className="form-examples-list">
              {exampleDescriptions.map((example, index) => (
                <li key={index} className="form-example-item">
                  <button
                    type="button"
                    className="form-example-button"
                    onClick={() => setDescription(example)}
                    disabled={isBuilding}
                  >
                    {example}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
              disabled={isBuilding}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!description.trim() || isBuilding}
            >
              {isBuilding ? 'Building...' : 'Build List'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

